<template>
  <span>
    <v-dialog max-width="500px" persistent v-model="dialog">
      <template #activator="{on}">
        <span v-on="on">
          <slot>
            <v-tooltip bottom>
              {{ $t("global.edit") }}
              <template #activator="{on: tooltip}">
                <v-btn icon v-on="tooltip">
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </slot>
        </span>
      </template>

      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("settings.delegationRate.delegationRateForm.title") }}</span>
        </v-card-title>
        <v-card-text>
          <v-form lazy-validation ref="form" v-model="formValid">
            <country-select
              :label="$t('global.country') + '*'"
              :model.sync="delegationRateItem.country_symbol"
              :rules="delegationRateItem.rules().country_symbol"
            >
            </country-select>
            <currency-select :label="$t('global.currency') + '*'" :model.sync="delegationRateItem.currency" :rules="delegationRateItem.rules().currency">
            </currency-select>
            <v-text-field :label="$t('global.region')" :rules="delegationRateItem.rules().region" v-model="delegationRateItem.region"> </v-text-field>

            <amount-input
              :label="$t('global.diet') + '*'"
              :model.sync="delegationRateItem.amount"
              :rules="delegationRateItem.rules().amount"
              :suffix="delegationRateItem.currency"
            >
            </amount-input>

            <amount-input
              :label="$t('global.hotelLimit') + '*'"
              :model.sync="delegationRateItem.hotel_limit"
              :rules="delegationRateItem.rules().hotel_limit"
              :suffix="delegationRateItem.currency"
            >
            </amount-input>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="dialog = false" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
          <v-btn :disabled="!formValid || $store.getters['Ajax/loading']" @click.native="save" color="blue darken-1" text>{{ $t("global.save") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import CountrySelect from "src/components/CustomInputComponents/CountrySelect.vue";
import CurrencySelect from "src/components/CustomInputComponents/CurrencySelect.vue";
import DelegationRateItem from "src/models/settings/delegationRateItem";
import AmountInput from "src/components/CustomInputComponents/AmountInput.vue";

export default {
  name: "DelegationRateFormDialog",
  components: { AmountInput, CurrencySelect, CountrySelect },
  props: {
    id: {
      required: false,
      default: null
    },
    forGroups: {
      required: false,
      default: false
    },
    groupId: {
      required: false,
      default: null
    }
  },
  data: () => {
    return {
      delegationRateItem: new DelegationRateItem(),
      dialog: false,
      formValid: true
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        if (this.id != null) {
          this.delegationRateItem.load(this.id);
        }
      }
    }
  },
  created() {
    if (this.groupId != null) this.delegationRateItem.group_id = this.groupId;
  },
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        this.delegationRateItem
          .save()
          .then(resp => {
            if (resp.data.status === "DUPLICATED") {
              this.$store.dispatch("snackbarPush", {
                text: this.$t("settings.delegationRate.delegationRateForm.duplicated"),
                color: "error",
                position: "bottom"
              });
            } else {
              if (this.id == null) {
                this.delegationRateItem = new DelegationRateItem();
                if (this.groupId != null) this.delegationRateItem.group_id = this.groupId;
              }
              this.$store.dispatch("snackbarPush", {
                text: this.$t("global.saved")
              });
              this.$emit("saved");
              this.dialog = false;
            }
          })
          .catch(resp => {
            console.log(resp.response);
            if (resp.response.data.status === "DUPLICATED") {
              this.$store.dispatch("snackbarPush", {
                text: this.$t("settings.delegationRate.delegationRateForm.duplicated"),
                color: "error",
                position: "bottom"
              });
            }
          });
      }
    }
  }
};
</script>

<style scoped></style>
